/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/canvas_template/canvas/:canvas_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasIdCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasIdProps,
  EngagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasIdResult,
} from "./types";

export const postEngagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasId = reactQueryMutationAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasIdCacheKeys,
  ({
    appGroupId,
    canvasId,
    tagNames,
    workflowName,
  }: PostEngagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasIdProps): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasIdResult> => {
    return fetch(
      `/engagement/${appGroupId}/structural_template/canvas_template/canvas/${canvasId}`,
      "POST",
      {
        tag_names: tagNames,
        workflow_name: workflowName,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
